export default __webpack_public_path__ + "static/9_31-330670e8d879f38af00c39c02bb9a226.png";